import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastController } from 'ionic-angular';

/*
  Generated class for the ToastProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ToastProvider {

  constructor(public http: HttpClient, private toastCtrl: ToastController) {

  }

  presentToast(message, duration= 3000, position='bottom') {
    const toast = this.toastCtrl.create({ message, duration, position });
    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/providers/toast/toast.ts